/**
 * Every save that changed the inputs, newest first. Restoring makes a NEW version, so
 * nothing is ever lost by going back.
 */

import { useEffect, useState } from 'react';
import { useMAccountingStore, type MVersionRow } from '../../../store/m-accounting';

export function MVersions() {
  const versions = useMAccountingStore((s) => s.versions);
  const restore = useMAccountingStore((s) => s.restore);
  const current = useMAccountingStore((s) => s.project?.version);
  const [rows, setRows] = useState<MVersionRow[]>([]);

  useEffect(() => {
    void versions().then(setRows);
  }, [versions, current]);

  return (
    <div className="max-w-3xl">
      <p className="mb-3 text-sm text-gray-600">
        Each version is the set of figures entered on top of the baseline template. Restoring one makes it the
        newest version; nothing after it is deleted.
      </p>
      <ul className="divide-y divide-gray-200 rounded-lg border border-gray-200">
        {rows.map((row) => (
          <li key={row.version} className="flex items-center gap-4 px-4 py-2.5 text-sm">
            <span className="w-10 font-mono text-gray-500">v{row.version}</span>
            <span className="flex-1">
              <span className="block">{row.label || 'Figures changed'}</span>
              <span className="text-xs text-gray-500">
                {new Date(row.savedAt).toLocaleString()} · {row.inputCount} figure{row.inputCount === 1 ? '' : 's'} entered
              </span>
            </span>
            {row.current ? (
              <span className="text-xs font-medium text-emerald-700">Current</span>
            ) : (
              <button
                type="button"
                onClick={() => void restore(row.version)}
                className="rounded border border-gray-300 px-2 py-1 text-xs hover:bg-gray-50"
              >
                Restore
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
